import React, { useRef, useEffect } from 'react';
import styles from './VRCard.module.scss';
import Button from 'component/atom/forms/button/Button';
import { API_URL } from 'constants';
import { useBrandingContext } from 'app-context/BrandingsContext';
import { useFormikContext } from 'formik';
import { addOpacityToColor } from 'helpers/addOpacityToColor';
import SvgWithBranding from 'component/hoc/branding/withBrandingColor.hoc';

const VRCard = ({ item, length, playingId, setPlayingId, activeVoice }) => {
  const formik = useFormikContext();
  const audioRef = useRef(null);
  const { brandingData } = useBrandingContext();
  const { page_ButtonColor } = brandingData;
  useEffect(() => {
    if (playingId !== item.id) {
      audioRef.current.pause();
    }
  }, [playingId, item.id]);

  const handlePlay = () => {
    if (playingId === item.id) {
      audioRef.current.pause();
      setPlayingId(null);
    } else {
      audioRef.current.play();
      setPlayingId(item.id);
    }
  };

  const handleChosenVoice = () => {
    formik.setFieldValue('voiceId', item.id);
  };

  return (
    <div
      className={styles.card}
      style={{
        borderColor:
          activeVoice == item.id && formik?.values?.voiceId == item.id
            ? addOpacityToColor(page_ButtonColor)
            : '',
        backgroundColor:
          activeVoice == item.id || formik?.values?.voiceId == item.id
            ? addOpacityToColor(page_ButtonColor)
            : '',
      }}
      onClick={handleChosenVoice}
    >
      <div className={styles.header}>
        <div className={styles.record}>
          <Button
            className={styles['record-button']}
            svgClassName={styles.svg}
            type={playingId === item.id ? 'pause' : 'play'}
            onClick={handlePlay}
          />
          <div className={styles.title}>
            <h3>{item?.localName}</h3>
            <div className={styles.inner}>
              <h5>{item?.gender}</h5>
              {item.languages && (
                <span className={styles['rounded-text']}>{item.languages}</span>
              )}
            </div>
          </div>
        </div>

        {item?.localName?.includes('Multilingual') && (
          <div className={`${styles.custom}`}>
            {/* <SvgWithBranding type="custom" /> */}
            <p>Multilingual</p>
          </div>
        )}
      </div>

      <p>{item?.voiceName}</p>
      {item?.styleTags && (
        <div
          className={`${styles['subTitle-cont']} ${
            length ? styles['hide'] : ''
          }`}
        >
          {item?.styleTags?.split(',')?.map((tag, index) => (
            <p key={index} className={styles['rounded-text']}>
              {tag.trim()}
            </p>
          ))}
        </div>
      )}

      <audio
        ref={audioRef}
        src={`${API_URL}${item?.voiceSample}`}
        onEnded={() => setPlayingId(null)}
      />
    </div>
  );
};

export default VRCard;
